import { gql } from '@apollo/client'
import { CountryFragment } from './country'

export const INVOICE_FILTER_CHOICES_QUERY = gql`
  query InvoiceFilterChoices {
    invoiceFilterChoices {
      years
      counterparties
    }
  }
`

export const INVOICE_OVERVIEW_QUERY = gql`
  query InvoiceOverview($year: Int) {
    invoiceOverview(year: $year) {
      year
      openCount
      overdueCount
      paidCount
      amounts {
        currency
        openTotal
        overdueTotal
        paidTotal
      }
    }
  }
`

const InvoiceItemFragment = gql`
  fragment InvoiceItemFragment on InvoiceItemNode {
    id
    description
    descriptionAlt
    quantity
    price
    taxRate
    discountPercentage
  }
`
export const InvoiceFragment = gql`
  fragment InvoiceFragment on InvoiceNode {
    id
    number
    note
    noteAlt
    internalNote
    deliveryDate
    dueDate
    issueDate
    paymentMethod
    currency
    invoiceMark
    paid
    paidAt
    paymentReference
    cpName
    cpType
    cpTaxId
    cpStreet
    cpCity
    cpPostalCode
    cpCountry {
      ...CountryFragment
    }
    bankAccount {
      id
      iban
      bank
      swift
    }
    language
    languageAlt
    net
    tax
    total
    items {
      ...InvoiceItemFragment
    }
  }
  ${CountryFragment}
  ${InvoiceItemFragment}
`

export const INVOICE_LIST_QUERY = gql`
  query Invoices(
    $q: String,
      $year: Decimal,
      $month: Decimal,
      $cpName: String,
      $paid: Boolean,
      $periodBetween: String, $first: Int, $after: String) {
    invoices(
      q: $q,
      year: $year,
      month: $month,
      cpName: $cpName,
      paid: $paid,
      periodBetween: $periodBetween, first: $first, after: $after) {
      totalCount
      edges {
        node {
          ...InvoiceFragment
          createdBy {
            fullName
            email
          }
        }
      }
    }
  }
  ${InvoiceFragment}
`

export const INVOICE_MUTATION = gql`
mutation Invoice($input: InvoiceMutationInput!) {
  invoice(input: $input) {
    invoice {
      ...InvoiceFragment
    }
    errors {
      field
      messages
    }
  }
}
${InvoiceFragment}
`

export const INVOICE_DELETE_MUTATION = gql`
  mutation DeleteInvoice($id: ID!, $check: Boolean) {
    deleteInvoice(id: $id, check: $check) {
      success
      message
    }
  }
`

export const UPDATE_INVOICE_PAYMENT_STATUS_MUTATION = gql`
  mutation UpdateInvoicePaymentStatus($input: UpdateInvoicePaymentStatusMutationInput!) {
    updateInvoicePaymentStatus(input: $input) {
      invoice {
        ...InvoiceFragment
      }
      errors {
        field
        messages
      }
    }
  }
  ${InvoiceFragment}
`
